import React from 'react'
import Layout from '../../components/Layout'
export default function CoachingManagement() {
  return (
      <Layout>
      <div>CoachingManagement</div>
      </Layout>
  )
}
